<template>
	<div :class="{ 'is-open': isOpen }" class="step-container display-flex flex-column flex-justify-center">
		<OnBoardingSectionStepHeader @click.native="$emit('step-clicked')" :isOpen="isOpen" :stepDetails="stepDetails" />
		<component
			v-if="isOpen"
			v-on="$listeners"
			:class="{ show: isOpen }"
			:stepDetails="stepDetails"
			:is="stepDetails.component"
			class="step-content-container pl-9 mt-7"
		/>
	</div>
</template>

<script>
import OnBoardingSectionStepHeader from '@/components/Onboarding/OnBoardingFlow/OnBoardingSection/OnBoardingSectionStepHeader.vue';
export default {
	name: 'OnBoardingSectionStep',
	props: {
		isOpen: { type: Boolean },
		stepDetails: { type: Object },
	},
	components: { OnBoardingSectionStepHeader },
	computed: {
		isCompleted() {
			return this.stepDetails.isCompleted;
		},
	},
	methods: {},
	mounted() {},
	data() {
		return {};
	},
	watch: {
		isCompleted: {
			handler(newV, oldV) {
				if (newV && !oldV && this.isOpen) {
					this.$emit('open-next-step');
				}
			},
			immediate: true,
		},
	},
};
</script>

<style scoped lang="scss">
$transition-time: 0.3s;
.step-container {
	border-radius: 8px;
	background: var(--white);
	transition: $transition-time;
	border: 1px solid transparent;
	&:hover {
		border: 1px solid #5858ec;
		transition: $transition-time;
		box-shadow: 0px 3px 6px #00000029;
	}
	&:not(.is-open) {
		padding: 0px 50px 0px 16px;
		transition: $transition-time;
		&:active {
			filter: brightness(0.9);
			transition: $transition-time;
		}
	}
	&.is-open {
		border: 1px solid #5858ec;
		padding: 12px 50px 25px 16px;
		transition: $transition-time;
	}
}
.step-content-container {
	overflow: hidden;
	transition: $transition-time;
	&:not(.show) {
		height: 0px;
	}
}

::v-deep {
	// step components classes
	.on-boarding-step-explanation-text {
		font-size: 14px;
		line-height: 22px;
		font-weight: normal;
		color: var(--primary-font-color);
	}
	.on-boarding-step-finish-step-button {
		height: 30px !important;
		font-size: 14px !important;
		color: #ffffff !important;
		padding: 0px 24px !important;
		border-radius: 11px !important;
		font-weight: normal !important;
		letter-spacing: 0px !important;
		background: #5858ec !important;
	}
	.on-boarding-step-wrapper {
		flex-direction: row;
		@media (max-width: 1120px) {
			flex-direction: column-reverse;
		}
	}
}
</style>
